import { initGlobalState } from "qiankun"

const initalState = {
  dataOpened: false,
  save: false
}

const actions = initGlobalState(initalState)

export default actions
